import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
  REQUEST_INVENTORY_BATCHES,
  FETCH_INVENTORY_BATCHES_SUCCESS,
  FETCH_INVENTORY_BATCHES_FAILURE,
  REQUEST_PRODUCT_INVENTORY_BATCHES,
  FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS,
  FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE
} from './type'

import {
  WHOLESALE_BATCH_URL,
  INVENTORY_BATCH_URL,
  ADJUSTMENT_INVENTORY_BATCH_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

// Inventories Actions v1
export function fetchInventoryBatches(ProductNum) {
  return dispatch => {
    dispatch({ type: REQUEST_INVENTORY_BATCHES });
    return axios.get(WHOLESALE_BATCH_URL + ProductNum,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(fetchInventoryBatchesSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryBatchesFailure(err));
      });
  }
}

export function fetchInventoryBatchesSuccess(batches) {
  return {
    type: FETCH_INVENTORY_BATCHES_SUCCESS,
    payload: batches
  };
}

export function fetchInventoryBatchesFailure(error) {
  return {
    type: FETCH_INVENTORY_BATCHES_FAILURE,
    payload: error
  };
}

// Inventories Actions v2
export function postProductInventoryBatches(id, qty) {
  return (dispatch, getState) => {
    let batches = getState().wholesaleModal.productInventory.batches;
    if (!batches) {
      batches = [];
    }
    const computedData = {
      inventory_adjustment_lines: batches.map(elem => ({
        ...elem,
        quantity: qty,
      })),
      product: id,
    };
    
    return axios({
        method: 'post',
        url: ADJUSTMENT_INVENTORY_BATCH_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        data: computedData,
      })
      .then((response) => {
        alert('Modify inventory success.')
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        alert('Error modify inventory. Please check your fields or retry.');
      });
  }
}

export function fetchProductInventoryBatches(ProductNum) {
  return dispatch => {
    dispatch({ type: REQUEST_PRODUCT_INVENTORY_BATCHES });
    return axios({
        method: 'get',
        url: INVENTORY_BATCH_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        params: {
          belong_warehouse: false,
          product: ProductNum,
        },
      })
      .then((response) => {
        dispatch(fetchProductInventoryBatchesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchProductInventoryBatchesFailure(err));
      });
  }
}

export function fetchProductInventoryBatchesSuccess(batches) {
  return {
    type: FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS,
    payload: batches
  };
}

export function fetchProductInventoryBatchesFailure(error) {
  return {
    type: FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE,
    payload: error
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/wholesaleModal_actions.jsx